import { ApiError } from '@klarna-web-sdk/backend-bridge';
import { v4 as uuid } from 'uuid';
import { ZodError } from 'zod';
import { PaymentEvents, paymentEvents } from './paymentEvents';
import { PaymentTracker } from './paymentTracker';
import { reportToSentry } from './reportToSentry';
/**
 * CustomError class can be used to throw any internal errors were required.
 * Need to make sure these errors are handled later on with `handleError` function to log and emit.
 */
export class CustomError extends Error {
    constructor(type, message, originalError) {
        super();
        this.type = type;
        this.message = message;
        this.originalError = originalError;
    }
}
/**
 * Handle errors gracefully then log to server and emit the error towards integrator.
 * If an originalError is of type `CustomError` then it will be used to override the message and type.
 */
export function handleError(type, message, originalError) {
    const result = {
        type,
        message,
        errorId: uuid(),
    };
    if (originalError instanceof CustomError) {
        return handleError(originalError.type, originalError.message, originalError.originalError);
    }
    if (originalError instanceof ApiError && originalError.response) {
        const response = originalError.response;
        if (response.error_id)
            result.errorId = response.error_id;
        if (response.error_type)
            result.type = response.error_type;
        if (response.error_message)
            result.message = response.error_message;
    }
    if (originalError instanceof ZodError) {
        result.fields = originalError.issues.map((issue) => ({
            attribute: issue.path.join('.'),
            reason: issue.message,
        }));
    }
    const tracker = PaymentTracker.getInstance();
    if (tracker) {
        tracker.event('error', result);
    }
    PaymentEvents.getInstance().emit(paymentEvents.ERROR, result);
    if (!(originalError instanceof ApiError)) {
        reportToSentry({
            errorID: result.errorId,
            errorMessage: result.message,
            errorType: result.type,
            originalError,
        });
    }
    // TODO: log errors in debug mode - KPC-1239
    // TODO: enable datadog dashboard for monitoring errors - KPC-1276
}
